import { SkillControlSignInCompleteDTO, SkillControlSignInStartDTO } from 'models/dto/ai/skillControlConnectionDTO';
import AppError from 'utils/appError';
import http from './httpService';

//the signed-in user's own sign-in at SkillControl (phase 22), in a popup: start hands out the authorization page,
//complete turns the code the callback page handed over into the sign-in. The environment's SkillControl is configured
//on the API, nothing is connected per organization; a refusal comes back as a coded 400 (MCPCONN0001-0007)

export async function apiStartSkillControlSignIn(accessToken: string): Promise<string> {
  try {
    const ar = await http.post<SkillControlSignInStartDTO>(
      '/ai/skillcontrol/me/authorize',
      undefined,
      http.getRequestConfig(accessToken),
    );

    return ar.data?.authorizationUrl ?? '';
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

export async function apiCompleteSkillControlSignIn(code: string, state: string, accessToken: string): Promise<void> {
  try {
    await http.post(
      '/ai/skillcontrol/me/authorize/complete',
      new SkillControlSignInCompleteDTO(code, state),
      http.getRequestConfig(accessToken),
    );
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}
